import { Card } from "@fanduel/og-fe-library";
import BelmontStakesSeo from "@/components/horseRacing/trackInfo/BelmontStakesSeo";
import BreedersCupSeo from "@/components/horseRacing/trackInfo/BreedersCupSeo";
import KentuckyDerbySeo from "@/components/horseRacing/trackInfo/KentuckyDerbySeo";
import PreaknessStakesSeo from "@/components/horseRacing/trackInfo/PreaknessStakesSeo";
import Flags from "@/components/svg/Flags";
import { SEO_TRACK } from "@/constants/horseRacing";
import { Hr_PastTrack } from "@/graphql/gql/graphql";
import { getLocation } from "@/utils/horseRacing";
import styles from "./trackInfo.module.scss";

interface TrackInfoProps {
  numRaces?: number;
  trackDetails: Hr_PastTrack;
}

const seoContentByTrack: Record<string, React.ReactNode> = {
  [SEO_TRACK.CHURCHILL_DOWNS]: <KentuckyDerbySeo />,
  [SEO_TRACK.PIMLICO]: <PreaknessStakesSeo />,
  [SEO_TRACK.SARATOGA_RACE_COURSE]: <BelmontStakesSeo />,
  [SEO_TRACK.DEL_MAR]: <BreedersCupSeo />,
};

const TrackInfo = ({ trackDetails, numRaces }: TrackInfoProps) => {
  const { location, imageLink, name: trackName } = trackDetails;

  return (
    <div className={styles.container}>
      <Card
        variant="elevation"
        elevation="mid"
        className={styles.infoContainer}
      >
        {location?.country ? (
          <p>
            <span>Location:</span>
            {getLocation(location)}
            <Flags countryCode={location.country} />
          </p>
        ) : (
          ""
        )}
        {trackName ? seoContentByTrack[trackName] : null}
        {imageLink ? (
          <p>
            <span>Website:</span>
            <a href={imageLink}>{imageLink}</a>
          </p>
        ) : (
          ""
        )}
      </Card>
      <p className={styles.numRacesText}>
        Next Races in this track: <span>({numRaces} Races)</span>
      </p>
    </div>
  );
};

export default TrackInfo;
